import React from 'react'
import { BsSearch } from 'react-icons/bs'
import { Link } from 'react-router-dom'

function Complete() {
    return (
        <div className='flex justify-center'>
            <div className="w-11/12 md:w-9/12 lg:w-7/12">
                <div className="bg-white dark:bg-card-dark rounded-xl shadow-md border border-border-light dark:border-border-dark p-6 sticky top-6">
                    <div className="p-6 md:p-8">
                        <div className="border-l-4 border-primary pl-4 py-2">
                            <p className='font-bold text-lg mb-3'>Thanks for Shoping with us!</p>

                            <div className="prose prose-gray dark:prose-invert max-w-none text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                                <p>
                                    We’ll keep you updated on your order status via email. If you already have an account, you can view your order and payment details in your{' '}
                                    <Link to="/auth/orders" className="text-secondary font-medium hover:underline">
                                        Orders
                                    </Link>
                                    .
                                </p>
                                <p>
                                    If not, you can create an account using the email you just provided to access your order history anytime.
                                </p>
                                <p className="mt-3 flex items-center gap-1.5">
                                    <span><BsSearch className='h-6 w-6'/></span>
                                    <span>
                                        Don’t see our emails? Please check your <strong>Spam</strong> or <strong>Promotions</strong> folder.
                                    </span>
                                </p>
                            </div>

                            <div className="text-center mt-6">
                                <Link
                                    to="/products"
                                    className="inline-block px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-red-800 transition"
                                >
                                    Continue Shopping
                                </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Complete